import Api from '@/utils/api'
import BasicConfig from '@/config/basic'

// 获取月子中心订单列表
export function getMaternityCenterOrders(query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/list`, { params: query })
}
// 获取月子中心订单详情
export function getMaternityCenterOrderProfile(id, query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/${id}/detail`, { params: query })
}

/**
 * 从订单详情接口成功返回中取出业务 VO（含客户信息、technicians 专属产康师等）。
 * 兼容：HTTP body 为 { code, data: { …VO } } 经拦截器解一层后，仍残留内层 { data: VO } 的情况。
 * @param {{ data?: unknown }} apiResult - 一般为 axios 拦截器处理后的 { data, meta }
 * @returns {Record<string, unknown>}
 */
function looksLikeMaternityOrderDetailVo(o) {
  return (
    o != null &&
    typeof o === 'object' &&
    !Array.isArray(o) &&
    ('technicians' in o ||
      'customerName' in o ||
      'maternalInfo' in o ||
      'packageName' in o ||
      'packageId' in o)
  )
}

export function normalizeMaternityOrderDetailFromApiResult(apiResult) {
  const layer = apiResult?.data
  if (layer == null || typeof layer !== 'object') return {}
  if (looksLikeMaternityOrderDetailVo(layer)) return layer
  const nested = layer.data
  if (nested != null && typeof nested === 'object' && !Array.isArray(nested) && looksLikeMaternityOrderDetailVo(nested)) {
    return nested
  }
  return layer
}
// 获取月子中心自选项目列表
export function getMaternityCenterSchoiceProjects(id, query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/${id}/choice-projects`, { params: query })
}
// 获取产后复原项目列表
export function getMaternityCenterChanKangProjects(id, query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/${id}/chankang-projects`, { params: query })
}
export function getMaternityCenterOrderProjectArray(id, query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/${id}/projects`, { params: query })
}
export function getMaternityCenterOrderVoucher(id, query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/${id}/voucher`, { params: query })
}
export function getMaternityCenterOrderFamily(id, query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/${id}/family`, { params: query })
}
export function getMaternityCenterOrderPromotion(id, query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/${id}/promotion`, { params: query })
}
export function getMaternityCenterOrderGift(id, query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/${id}/gift`, { params: query })
}
// 获取预订单操作记录
export function getMaternityCenterAffects(id, query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/${id}/affects`, { params: query })
}
// 获取特别声明内容
export function getMaternityCenterSpecialNote(query = {}) {
  return Api.get(`${BasicConfig.jDomain}/order-total/special-announcement`, { params: query })
}

// 指派专属订单负责人
export function assignDedicatedTechnician(id, body) {
  return Api.post(`${BasicConfig.jDomain}/order-total/${id}/principals`, body)
}

// 获取中医订单列表
// api.js 会自动从 Redux 获取 accessToken 并添加到请求中
// 注意：中医订单的数据结构可能与月子中心不同
export function getTraditionalMedicineOrders(query = {}) {
  // TODO: 对接真实API
  // return Api.get(`${BasicConfig.jDomain}/api/dispatchingJ/orders/traditional-medicine`, { params: query })
  
  // 模拟API响应 - 中医的数据结构可能不同
  const mockList = [
    {
      id: 1,
      orderNo: 'TM20240209001',
      customerName: '陈师傅',
      customerPhone: '13900139000',
      storeId: 17,
      storeName: '中医理疗馆',
      serviceType: 'acupuncture',
      status: 'in_progress',
      amount: 680.00,
      createTime: '2024-02-09 09:00:00',
      startTime: '2024-02-09 14:00:00',
      endTime: '2024-02-09 15:00:00',
      staffName: '刘中医',
      isAbnormal: false,
      isOvertime: false
    },
    {
      id: 2,
      orderNo: 'TM20240209002',
      customerName: '周女士',
      customerPhone: '13900139001',
      storeId: 17,
      storeName: '中医理疗馆',
      serviceType: 'massage',
      status: 'booked',
      amount: 380.00,
      createTime: '2024-02-09 10:30:00',
      startTime: '2024-02-10 15:00:00',
      endTime: '2024-02-10 16:00:00',
      staffName: '王推拿师',
      isAbnormal: false,
      isOvertime: false
    },
    {
      id: 3,
      orderNo: 'TM20240209003',
      customerName: '吴先生',
      customerPhone: '13900139002',
      storeId: 17,
      storeName: '中医理疗馆',
      serviceType: 'herbal',
      status: 'completed',
      amount: 1200.00,
      createTime: '2024-02-08 16:00:00',
      startTime: '2024-02-08 16:00:00',
      endTime: '2024-02-08 17:00:00',
      staffName: '李药师',
      isAbnormal: false,
      isOvertime: false
    }
  ]
  
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {
          list: mockList,
          total: mockList.length,
          pageNumber: query.page || 1,
          pageSize: query.pageSize || 20
        }
      })
    }, 300)
  })
}

// 获取牙医订单列表
// api.js 会自动从 Redux 获取 accessToken 并添加到请求中
// 注意：牙医订单的数据结构可能与其他类型不同
export function getDentalOrders(query = {}) {
  // TODO: 对接真实API
  // return Api.get(`${BasicConfig.jDomain}/api/dispatchingJ/orders/dental`, { params: query })
  
  // 模拟API响应 - 牙医的数据结构可能不同
  const mockList = [
    {
      id: 1,
      orderNo: 'DT20240209001',
      customerName: '郑先生',
      customerPhone: '13700137000',
      storeId: 18,
      storeName: '口腔诊所',
      serviceType: 'cleaning',
      status: 'booked',
      amount: 280.00,
      createTime: '2024-02-09 08:00:00',
      startTime: '2024-02-10 10:00:00',
      endTime: '2024-02-10 11:00:00',
      staffName: '赵医生',
      isAbnormal: false,
      isOvertime: false
    },
    {
      id: 2,
      orderNo: 'DT20240209002',
      customerName: '孙女士',
      customerPhone: '13700137001',
      storeId: 18,
      storeName: '口腔诊所',
      serviceType: 'filling',
      status: 'in_progress',
      amount: 580.00,
      createTime: '2024-02-09 09:30:00',
      startTime: '2024-02-09 14:00:00',
      endTime: '2024-02-09 15:30:00',
      staffName: '钱医生',
      isAbnormal: false,
      isOvertime: false
    },
    {
      id: 3,
      orderNo: 'DT20240209003',
      customerName: '周先生',
      customerPhone: '13700137002',
      storeId: 18,
      storeName: '口腔诊所',
      serviceType: 'whitening',
      status: 'completed',
      amount: 1280.00,
      createTime: '2024-02-08 15:00:00',
      startTime: '2024-02-08 15:00:00',
      endTime: '2024-02-08 17:00:00',
      staffName: '李医生',
      isAbnormal: false,
      isOvertime: false
    }
  ]
  
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {
          list: mockList,
          total: mockList.length,
          pageNumber: query.page || 1,
          pageSize: query.pageSize || 20
        }
      })
    }, 300)
  })
}

// 获取到家服务订单列表
// api.js 会自动从 Redux 获取 accessToken 并添加到请求中
// 注意：到家服务订单的数据结构可能与其他类型不同
export function getHomeServiceOrders(query = {}) {
  // TODO: 对接真实API
  // return Api.get(`${BasicConfig.jDomain}/api/dispatchingJ/orders/home-service`, { params: query })
  
  // 模拟API响应 - 到家服务的数据结构可能不同
  const mockList = [
    {
      id: 1,
      orderNo: 'HS20240209001',
      customerName: '冯女士',
      customerPhone: '13600136000',
      storeId: 19,
      storeName: '到家服务中心',
      serviceType: 'cleaning',
      status: 'in_progress',
      amount: 180.00,
      createTime: '2024-02-09 07:00:00',
      startTime: '2024-02-09 14:00:00',
      endTime: '2024-02-09 17:00:00',
      staffName: '陈阿姨',
      isAbnormal: false,
      isOvertime: false
    },
    {
      id: 2,
      orderNo: 'HS20240209002',
      customerName: '陈先生',
      customerPhone: '13600136001',
      storeId: 19,
      storeName: '到家服务中心',
      serviceType: 'cooking',
      status: 'booked',
      amount: 280.00,
      createTime: '2024-02-09 08:30:00',
      startTime: '2024-02-10 12:00:00',
      endTime: '2024-02-10 14:00:00',
      staffName: '张厨师',
      isAbnormal: false,
      isOvertime: false
    },
    {
      id: 3,
      orderNo: 'HS20240209003',
      customerName: '楚女士',
      customerPhone: '13600136002',
      storeId: 19,
      storeName: '到家服务中心',
      serviceType: 'nursing',
      status: 'abnormal',
      amount: 380.00,
      createTime: '2024-02-08 10:00:00',
      startTime: '2024-02-08 10:00:00',
      endTime: '2024-02-08 12:00:00',
      staffName: '王护理',
      isAbnormal: true,
      isOvertime: false
    }
  ]
  
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {
          list: mockList,
          total: mockList.length,
          pageNumber: query.page || 1,
          pageSize: query.pageSize || 20
        }
      })
    }, 300)
  })
}

// 根据订单类型获取对应的API函数
export function getOrderApiByType(orderType) {
  const apiMap = {
    maternity_center: getMaternityCenterOrders,
    traditional_medicine: getTraditionalMedicineOrders,
    dental: getDentalOrders,
    home_service: getHomeServiceOrders
  }
  return apiMap[orderType] || getMaternityCenterOrders
}
